import React from "react";
import { Link } from "wouter";

import { Markdown } from "../../../../components/src/Markdown";

import tAccountChartLogic from "./TAccountChartLogic.md?raw";

export function TAccountChartLogicPage(): React.ReactElement {
    return (
        <div className="markdown-doc">
            <Link to="/taccountcharts2">T-account charts</Link>
            <Markdown markdown={tAccountChartLogic} />
        </div>
    );
}
